import React from 'react'

import { ForAccountType } from '../components/Auth/ForAccountType'
import { CreateProject } from '../components/Projects/CreateProject'
import { AccountTypePermissions } from '../domain/account-type.domain'

import { Page } from './shared/Page'

export const CreateProjectPage: React.FC = () => {
    return (
        <ForAccountType permission={AccountTypePermissions.ProjectCreate}>
            <Page>
                <CreateProject />
            </Page>
        </ForAccountType>
    )
}
